/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PrimaryButton } from 'components';
import {
  Typography,
} from '@mui/material';

import { useSelector } from 'react-redux';
import { useState } from 'react';
import { UploadResponse, UploadScenarios } from 'interfaces/file-uploader';
import { PlusIcon } from 'assets/icons';
import { selectSponsorContent } from 'base/auth/selectors';
import { IUpdateProfileForm } from '../../interface';
import SponsorLogoUploader from './components/sponsor-logo-uploader';

const SponsorsLogoForm = () => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext<IUpdateProfileForm>();
  const { fields, append, remove } = useFieldArray({ name: 'sponsors', control });

  const sponsorContent = useSelector(selectSponsorContent);
  const [sponsorContentUrls, setSponsorContentUrls] = useState<{
    url: string,
    action: string
  }[]>([]);

  const addSponsorContentUrl = (value: string) => {
    setSponsorContentUrls((oldSponsorContentUrls) => [...oldSponsorContentUrls, { url: value, action: '' }]);
  };

  const updateSponsorLogoUrl = (index: number, url: string, action: string) => {
    const tempList = [...sponsorContentUrls];
    tempList[index] = { url, action };
    setSponsorContentUrls(tempList);
  };

  const addSponsorLogo = () => {
    append({
      url: '', contentUrl: '',

    });
    addSponsorContentUrl('');
  };
  const removeSponsorLogo = (index: number) => {
    remove(index);
  };
  const handleInputChange = (index: number, input: string) => { setValue(`sponsors.${index}.contentUrl`, input); updateSponsorLogoUrl(index, input, ''); };
  const handleUpload = (
    index: number,
    res: UploadResponse,
  ) => {
    setValue(`sponsors.${index}`, {
      url: res.url, contentUrl: '',
    });
  };
  React.useEffect(() => {
    remove();
    setSponsorContentUrls([]);
    sponsorContent?.forEach((sponsor) => {
      append({
        url: sponsor.url, contentUrl: sponsor.contentUrl,
      });
      addSponsorContentUrl(sponsor.contentUrl);
    });
  }, [sponsorContent]);

  return (
    <>
      <div className="form-item">
        <Typography variant="h5" sx={{ mb: 2 }}>Sponsors</Typography>
      </div>
      <div className="row">
        {fields.map((item, i) => (
          <React.Fragment key={item.id}>
            {sponsorContentUrls[i]?.action !== 'delete'
              ? (
                <SponsorLogoUploader
                  index={i}
                  label={`sponsor #${i + 1}`}
                  imageLabel="Sponsor logo"
                  textFieldLabel="Sponsor Url"
                  handleRemove={removeSponsorLogo}
                  handleInputChange={handleInputChange}
                  handleFile={handleUpload}
                  scenario={UploadScenarios.expertSponsor}
                  currentText={sponsorContentUrls[i]?.url}
                  currentImageUrl={(sponsorContent?.length) > i ? sponsorContent[i]?.url : ''}
                  errors={errors}
                />
              ) : ''}
          </React.Fragment>
        ))}
      </div>
      <PrimaryButton
        startIcon={<PlusIcon sx={{ color: '#fff' }} />}
        onClick={addSponsorLogo}
      >
        Add a new sponsor
      </PrimaryButton>
    </>
  );
};

export default SponsorsLogoForm;
